module.exports = __webpack_public_path__ + "932e22b8895e51ff65d41d35efaf7eb7.png";